import React, { Component } from "react";
import axios from "axios";

export default class CreateUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
    };
    this.onChangUsername = this.onChangUsername.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }
  onChangUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  async onSubmit(e) {
    e.preventDefault();
    const user = {
      username: this.state.username,
    };
    // console.log(user);

    await axios
      .post("https://backend-of-tracker.herokuapp.com/users/add", user)
      .then((res) => alert(res.data))
      .catch((err) => console.log("Error: " + err));

    this.setState({
      username: "",
    });
  }

  render() {
    return (
      <form onSubmit={this.onSubmit}>
        <div className="form-group">
          <label htmlFor="">Username</label>
          <input
            value={this.state.username}
            onChange={this.onChangUsername}
            className="form-control"
            type="text"
          />
        </div>
        <div className="form-group">
          <input
            className="btn btn-primary"
            type="button"
            value="Create User"
            onClick={this.onSubmit}
          />
        </div>
      </form>
    );
  }
}
